var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8NigerCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff6d00",
    d: "M24,4C15.296,4,7.911,9.571,5.162,17.333h37.675C40.089,9.571,32.704,4,24,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M42.838,30.667C43.577,28.579,44,26.341,44,24c0-2.341-0.423-4.579-1.162-6.667H5.162 C4.423,19.421,4,21.659,4,24c0,2.341,0.423,4.579,1.162,6.667H42.838z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 5,
    fill: "#ff6d00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00c853",
    d: "M23.999,44h0.002c8.704,0,16.088-5.571,18.836-13.333H5.162C7.911,38.429,15.295,43.999,23.999,44z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8NigerCircular);
export default __webpack_public_path__ + "static/media/icons8-niger-circular.7e96273f482dd548cfd7147007e8dba1.svg";
export { ForwardRef as ReactComponent };